import { useRecoilValue } from "recoil";
import { configState } from "../context/configState";

export const useChainInfo = () => {
  const { chainInfo, ibcChainInfo } = useRecoilValue(configState);

  /*
   * Returns the chainInfo data of secret chain
   */
  const getChainInfoData = () => {
    return chainInfo;
  };

  /*
   * Returns the chainId of secret chain
   */
  const getChainId = () => {
    return chainInfo.chainId;
  };

  /*
   * Returns the RPC url of secret chain
   */
  const getRpcUrl = () => {
    return chainInfo.rpc;
  };

  /*
   * Returns the REST url of secret chain
   */
  const getRestUrl = () => {
    return chainInfo.rest;
  };

  /*
   * Returns the chainId of the mentioned token chain
   */
  const getIbcChainId = (tokenName: string) => {
    return ibcChainInfo[tokenName].chainId;
  };

  /*
   * Returns the RPC url of the mentioned token chain
   */
  const getIbcRpcUrl = (tokenName: string) => {
    return ibcChainInfo[tokenName].rpc;
  };

  /*
   * Returns the REST url of the mentioned token chain
   */
  const getIbcRestUrl = (tokenName: string) => {
    return ibcChainInfo[tokenName].rest;
  };

  return {
    getChainInfoData,
    getChainId,
    getRpcUrl,
    getRestUrl,
    getIbcChainId,
    getIbcRestUrl,
    getIbcRpcUrl,
  };
};
